import React from 'react';

export const BrandText = ({ className = '' }) => {
  return (
    <span className={`font-black tracking-tight ${className}`}>
      <span className="text-white">THE </span>
      <span className="text-green-500">MOON MEDIA</span>
    </span>
  );
};
